import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, TemplateRef } from '@angular/core';
import {SpinnerService} from './spinner.service';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [NgbModule]
})
export class SpinnerComponent {

  constructor( public spinnerService: SpinnerService ) {}

  isTemplate(spinner : any) { return spinner.textOrTpl instanceof TemplateRef; }

}
